export const XXX_SET_ORDER = (state, order) => {
  state.order = order;
}